export enum Dash {
    HYPHEN = "-", // Regular dash
    EN = "–", // Longer dash
    EM = "—", // Longest dash
}
